// Grid items on the home and exhibitions/events pages carry margins as a
// percentage (0–25) of the column they sit in, with an optional separate value
// below the md breakpoint (see assets/css/margin.css).
//
// They can't go out as plain inline `margin-*` declarations: an inline style
// has no media query, and it would also outrank the mobile rule. So each side
// goes out as a custom property the stylesheet picks between.
//
// Every one of the eight properties is always emitted, including the zeroes.
// Custom properties inherit, and the hover panel is a descendant of the tile
// that positions it — leaving one out would let the panel silently pick up the
// tile's margin instead of its own.

const SIDES = ['Top', 'Right', 'Bottom', 'Left'] as const

const percentage = (value: unknown) =>
  typeof value === 'number' && Number.isFinite(value) && value > 0 ? `${value}%` : '0%'

export const marginStyle = (
  source: Record<string, unknown> | null | undefined,
  { field = 'margin' }: { field?: string } = {},
): Record<string, string> => {
  const values = source ?? {}
  const style: Record<string, string> = {}

  for (const side of SIDES) {
    const key = `${field}${side}`
    const mobile = values[`${key}Mobile`]
    const name = `--margin-${side.toLowerCase()}`

    style[name] = percentage(values[key])
    // An empty mobile field means "same as desktop"; a mobile 0 is a real
    // answer and has to survive next to a non-zero desktop value, so the
    // fallback is decided here rather than by a CSS var default.
    style[`${name}-mobile`] =
      mobile === null || mobile === undefined ? style[name] : percentage(mobile)
  }

  return style
}
